export const getIsLoading = (state) => state.indexGrab.isApiLoading;
export const getIndexFromCroppedImage = (state) => {
    if (!state.indexGrab.croppedImageIndex) return null;
    return state.indexGrab.croppedImageIndex;
};
